import React, { memo, useContext } from 'react';
import { Title } from '@catalogo/ui-americanas-desktop-review/src/components/atoms';
import { Margin } from '../../atoms';
import { Container, AuxiliaryTitleWrapper, NoCommentsStyled, Link } from './Styled';
import { context } from '../../../context';

const NoneReview = () => {
  const { config, dispatchMetrics } = useContext<any>(context);
  const { productId } = config;
  const href = `/avaliacao/${productId}`;

  return (
    <Container>
      <AuxiliaryTitleWrapper>
        <Title fontSize={18}>comentários</Title>
      </AuxiliaryTitleWrapper>
      <NoCommentsStyled>
        <b>esse produto ainda não tem comentários</b>
        <Margin top={10} />
        <p>Avalie o produto e faça o primeiro :)</p>
        <Margin top={20} />
        <Link
          onClick={() => {
            dispatchMetrics('event:track', {
              category: 'avaliacao-pdp',
              action: 'avaliar-produto',
              label: `produto-sem-comentarios`,
            });
          }}
          href={href}
        >
          avaliar produto
        </Link>
      </NoCommentsStyled>
    </Container>
  );
};

const NoComments = memo(NoneReview);

export default NoComments;
export { NoComments };
